/**
 * Some app wide filters
 */
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

dayjs.extend(calendar);

/**
 * the 'speed' filter converts m/s values into km/h.
 */
angular.module("app").filter("speed", function () {
	return function (speed) {
		return speed * 3.6;
	};
});


/**
 * Mettre en forme la date
 */
angular.module("app").filter("dateShort", function () {
	return function (input) {
		return dayjs(input).subtract(2, "hours").format("lll");
	};
});

angular.module("app").filter("makePositive", function() {
	return function(num) { return Math.abs(num); };
});

/**
 * Mettre en forme la date
 */
angular.module("app").filter("dateShortWithout1Hour", function () {
	return function (input) {
		return dayjs(input).subtract(1, "hours").format("lll");
	};
});

angular.module("app").filter("networkType", function(){
	return function(networkType){
		switch (networkType) {
			case "SCHOLAR": return "Scolaire";
			case "COMMERCIAL": return "Commercial";
			case "SNCF": return "SNCF";
			case "TICKETING": return "KorriGo";
			case "URBAN": return "Urbain";
		}
	}
});

angular.module("app").filter("registrationStatus", function(){
	return function(registrationStatus){
		switch (registrationStatus) {
			case "WAITING_FOR_RENEWAL":
				return "En attente de renouvellement";
			case "SUBSCRIPTION_IN_PROGRESS":
				return "En cours d'inscription";
			case "WAITING_FOR_DOCUMENTS":
				return "En attente de documents";
			case "WAITING_FOR_EXAMINATION":
				return "En cours d'instruction";
			case "PRE_ASSIGNED":
				return "Pré affectation";
			case "ARCHIVED":
				return "Archivé";
			case "REFUSED":
				return "Refusé";
			case "WAITING_FOR_ASSIGNMENT":
				return "En attente d'affectation";
			case "FULLY_ASSIGNED":
				return "Affecté";
			case "FACTURED":
				return "Facturé";
			case "ACTIVATED":
				return "Activé";
		}
	}
});

angular.module("app").filter("vehicleFillingFillType", function(){
	return function(registrationStatus){
		switch (registrationStatus) {
			case "ACTIVATED":
				return "Activés";
			case "ASSIGNED":
				return "Affectés";
			case "PRE_ASSIGNED":
				return "Pré-affectés";
			case "WAITING_FOR_ASSIGNMENT":
				return "En attente d'affectation";
			case "ASSIGNED_PRE_ASSIGNED":
				return "Affectés + Pré-affectés";
			case "TOTAL":
				return "Tous";
		}
	}
});

angular.module("app").filter("propsFilter", function () {
	return function (items, props) {
		var out = [];

		if (angular.isArray(items)) {
			var keys = Object.keys(props);

			items.forEach(function (item) {
				var itemMatches = false;

				for (var i = 0; i < keys.length; i++) {
					var prop = keys[i];
					var text = props[prop].toLowerCase();
					if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
						itemMatches = true;
						break;
					}
				}

				if (itemMatches) {
					out.push(item);
				}
			});
		} else {
			// Let the output be the input untouched
			out = items;
		}

		return out;
	};
});

/**
 * Custom filter to compare adresses Sanitized
 * - replace accented characters
 * - lowercase
 * - replace "SAINT" by "ST" (only if "SAINT" is a whole word)
 * - replace "-" by " "
 */
angular.module("app").filter("sanitizeAddressFilter", ["Utils", function (Utils) {
	return function (items, props) {
		var out = [];
		if (angular.isArray(items)) {
			items.forEach(function (city) {
				if(city.name==null) return;
				if (Utils.sanitizeAddress(city.name+" "+city.line5).indexOf(Utils.sanitizeAddress(props)) !== -1) {
					out.push(city);
					return;
				}
				if (Utils.sanitizeAddress(city.zipCode).indexOf(Utils.sanitizeAddress(props)) !== -1) {
					out.push(city);
					return;
				}
			});
		}
		return out;
	};
}]);

/**
 * Mettre en forme la date
 */
angular.module("app").filter("dateShortSimple", function () {
	return function (input) {
		return dayjs(input).format("lll");
	};
});

/**
 * Filter à partir d'une date
 */
angular.module("app").filter("filterDateStart", function () {
	return function (items, from) {
		var inf = dayjs(from);
		var arrayToReturn = [];
		for (var i = 0; i < items.length; i++) {
			if (items[i].serviceDatetime != null) {
				var dateCompStart = dayjs(dayjs(items[i].serviceDatetime).format());
				if (inf.isBefore(dateCompStart)) {
					arrayToReturn.push(items[i]);
				}
			}
		}
		return arrayToReturn;
	};
});


/**
 * Filtrer les dates
 */
angular.module("app").filter("filterDateToDate", function () {
	return function (items, from, to) {

		function toDate(dateStr) {
			var parts = dateStr.split("/");
			return new Date(parseInt(parts[2], 10),
				parseInt(parts[1], 10) - 1,
				parseInt(parts[0], 10));
		}

		var inf = toDate(from);
		var sup = toDate(to);
		var arrayToReturn = [];
		for (var i = 0; i < items.length; i++) {
			var dateCompEnd = new Date(toDate(items[i].arrivalDatetime));
			var dateCompStart = new Date(toDate(items[i].departureDatetime));
			if (inf <= dateCompStart && dateCompEnd <= sup) {
				arrayToReturn.push(items[i]);
			}
		}
		return arrayToReturn;
	};
});


/**
 * Duration filter takes milliseconds and returns a string representation like "3 jours 2h33m26s"
 */
angular.module("app").filter("duration", function () {
	return function (duration) {
		duration = duration / 1000;
		var days = Math.floor(duration / 86400);
		var hours = Math.floor(duration / 3600) % 24;
		var minutes = Math.floor(duration / 60) % 60;
		var seconds = Math.floor(duration % 60);
		if (seconds + minutes + hours + days === 0 && duration !== 0) {
			return "< 1s";
		} else {
			return (days ? days + " j " : "") + (hours ? hours + "h" : "") + (minutes ? minutes + "m" : "") + (seconds ? seconds + "s" : "");
		}
	};
});

angular.module("app").filter("day", function () {
	return function (day) {
		switch (day.toUpperCase()) {
		case "MONDAY":
			return "Lundi";
		case "TUESDAY":
			return "Mardi";
		case "WEDNESDAY":
			return "Mercredi";
		case "THURSDAY":
			return "Jeudi";
		case "FRIDAY":
			return "Vendredi";
		case "SATURDAY":
			return "Samedi";
		case "SUNDAY":
			return "Dimanche";
		default:
			return day;
		}
	};
});

angular.module("app").filter("stateSubscriber", function () {
	return function (state) {
		switch (state) {
		case "WAITING_APPROVAL":
			return "Attente acceptation";
		case "ACTIVE":
			return "Compte Actif";
		case "ARCHIVED":
			return "Archivé";
		case "WAITING_FOR_RENEWAL":
			return "Attente renouvellement";
		default:
			return state;
		}
	};
});

angular.module("app").filter("paymentAttemptStatus", function () {
	return function (state) {
		switch (state) {
		case "SENDED":
			return "Envoyé";
		case "ARCHIVED":
			return "Payé";
		case "REJECTED":
			return "Rejeté";
		case "ECHEC":
			return "Erreur rencontrée";
		default:
			return state;
		}
	};
});

angular.module("app").filter("statusBill", function () {
	return function (state) {
		switch (state) {
		case "ARCHIVED":
			return "Payée";
		case "TO_CASH":
		case "SENDED":
			return "Transaction en cours";
		case "TO_CASH_SCHEDULED":
			return "Opérations à venir";
		case "CANCELED":
			return "Annulée";
		case "WAIT":
			return "En attente";
		case "REJECTED":
			return "Rejetée";
		case "TELETRANSMISSION":
			return "Transaction en cours (télétransmis)";
		case "ECHEC":
			return "En echec";
		case undefined:
		case null:
			return "Aucun règlement attaché";
		default:
			return state;
		}
	};
});

angular.module("app").filter("statusTravelerInformation", function () {
	return function (state) {
		switch (state) {
		case "ARCHIVED":
			return "Terminée";
		case "LOCK_TO_START":
			return "Démarrage planifié";
		case "CREATED":
			return "Créée";
		case undefined:
		case null:
		default:
			return state;
		}
	};
});

angular.module("app").filter("periodicBill", function () {
	return function (state) {
		switch (state) {
		case "UNIQUE":
			return "Annuel (Comptant)";
		case "QUARTERLY":
			return "Trimestriel";
		case "MONTHLY":
			return "Mensuel";
		default:
			return state;
		}
	};
});

angular.module("app").filter("statePayment", function () {
	return function (state) {
		switch (state) {
		case "ARCHIVED":
			return "Payée";
		case "TO_CASH":
			return "À encaisser";
		case "DRAFT_COPY":
			return "Brouillon";
		case "CANCELED":
			return "Annulée";
		case "NULL":
			return "Sans paiement";
		default:
			return state;
		}
	};
});

angular.module("app").filter("categoryPayment", function () {
	return function (state) {
		switch (state) {
		case "PAYMENT":
			return "FACTURE";
		case "REFUND":
			return "AVOIR";
		default:
			return state;
		}
	};
});

angular.module("app").filter("categoryTravelerInformation", function () {
	return function (state) {
		switch (state) {
		case "SUBSCRIBER":
			return "Elève";
		case "SCHOOL_PERSONNEL":
			return "Equipe scolaire";
		case "PARENT":
			return "Parent";
		default:
			return state;
		}
	};
});

angular.module("app").filter("trackMsgStatus", function () {
	return function (state) {
		switch (state) {
		case "WAIT":
			return "En attente de distribution";
		case "TRANSMITTED":
			return "Transmis";
		case "DUPLICATED":
			return "Doublon (non envoyé)";
		case "READ":
			return "Lu";
		case "REJECTED":
			return "Rejeté";
		case "BLACK_LIST":
			return "Refuse la réception";
		case "NOT_CONCERNED":
			return "Non concerné";
		default:
			return state;
		}
	};
});

angular.module("app").filter("indisciplineStatus", function () {
	return function (state) {
		switch (state) {
		case "CREATED":
			return "Attente de traitement";
		case "ARCHIVED":
			return "Traité";
		default:
			return state;
		}
	};
});

angular.module("app").filter("profileOsrm", function () {
	return function (state) {
		switch (state) {
		case "DRIVING":
			return "Voiture";
		default:
			return state;
		}
	};
});

angular.module("app").filter("processTypeTransaction", function () {
	return function (state) {
		switch (state) {
		case "AGENCY":
			return "AGENCE";
		default:
			return state;
		}
	};
});

angular.module("app").filter("statusCreditNote", function () {
	return function (state) {
		switch (state) {
		case "WAIT":
			return "En attente de traitement";
		case "ARCHIVED":
			return "Traité";
		default:
			return state;
		}
	};
});

angular.module("app").filter("paymentType", function () {
	return function (state) {
		switch (state) {
		case "CHECK":
			return "Chèque";
		case "CB":
			return "Carte Bancaire";
		case "CB_AGENCY":
			return "Carte Bancaire en agence";
		case "CB_WEB":
			return "Carte Bancaire par internet";
		case "SOCIAL":
			return "Chèque social";
		case "CASH":
			return "Espèce";
		case "BANK_DIRECT_DEBIT":
			return "Prélèvement Bancaire";
		case "OTHER":
			return "Autre";
		case "":
		case "NULL":
		case null:
		case undefined:
			return "Non Communiqué";
		default:
			return state;
		}
	};
});

angular.module("app").filter("logActionTranslate", function () {
	return function (state) {
		switch (state) {
		case "PAYMENT_ORDER_ADD":
			return "Ajout d'un ordre de paiement";
		case "PAYMENT_ORDER_CLOSED":
			return "Clôture d'un ordre de paiement";

		case "INDISCIPLINE_ADD":
			return "Ajout d'une indiscipline";
		case "INDISCIPLINE_SENDED":
			return "Envoi d'une indiscipline par email";
		case "INDISCIPLINE_UPDATE":
			return "Modification d'une indiscipline";
		case "INDISCIPLINE_DELETE":
			return "Suppression d'une indiscipline";

		case "BILL_PAYMENT_REFUND":
			return "Remboursement d'une facture";
		case "BILL_PAYMENT_INDIVIDUAL_PAY":
			return "Transfert d'un paiement sur facture unique";
		case "BILL_PAYMENT_CHANGE_MEAN_PAYMENT":
			return "Changement du moyen de paiement";
		case "BILL_PAYMENT_ARCHIVED":
			return "Passage d'une facture à Payée";
		case "BILL_PAYMENT_TO_CASH":
			return "Passage d'une facture à Attente d'encaissement";
		case "BILL_SENDED":
			return "Envoi d'une facture par email";
		case "BILL_DOWNLOADED":
			return "Téléchargement d'une facture";

		case "CREDIT_NOTE_ADD":
			return "Ajout d'un avoir";
		case "CREDIT_NOTE_ARCHIVED":
			return "Passage d'un avoir à Remboursé";
		case "CREDIT_NOTE_SENDED":
			return "Envoi d'un avoir par email";
		case "CREDIT_NOTE_DOWNLOADED":
			return "Téléchargement d'un avoir";

		case "PAYMENT_ATTEMPT_SEND_EMAIL":
			return "Envoi d'un email avec les instructions de paiement";
		case "PAYMENT_ATTEMPT_SEND_EMAIL_PAYED":
			return "Envoi d'un email indiquant la réception du paiement";
		case "PAYMENT_ATTEMPT_ECHEC":
			return "Echec du réglement";

		case "TELETRANSMISSION_ADD":
			return "Envoi à la télétransmission";

		case "LEGAL_REPRESENTATIVE_RIB_ADD":
			return "Ajout d'un RIB à un représentant légal";
		case "LEGAL_REPRESENTATIVE_RIB_SEND_EMAIL":
			return "Envoi d'un mail demandant des informations pour le RIB";

		case "TRAVELER_INFORMATION_CAMPAIGN_ADD":
			return "Ajout d'une nouvelle campagne d'information voyageur";
		case "TRAVELER_INFORMATION_CAMPAIGN_SEND":
			return "Envoi d'une campagne d'information voyageur";
		case "TRAVELER_INFORMATION_CAMPAIGN_DELETE":
			return "Suppression d'une campagne d'information voyageur";
		case "TRAVELER_INFORMATION_CAMPAIGN_FILE_ADD":
			return "Ajout d'un fichier dans une campagne";
		case "TRAVELER_INFORMATION_CAMPAIGN_FILE_DELETE":
			return "Suppression d'un fichier dans une campagne";
		case "TRAVELER_INFORMATION_CAMPAIGN_ADD_USER":
			return "Ajout d'utilisateur(s) dans une campagne";
		case "TRAVELER_INFORMATION_CAMPAIGN_UPDATE":
			return "Mise à jour des options d'une campagne d'information voyageur";

		case "SUBSCRIBER_ADD":
			return "Ajout d'un abonné";
		case "SUBSCRIBER_UPDATE":
			return "Modification impactante d'un abonné";
		case "SUBSCRIBER_CHANGE_DROP_IN_CENTER" :
			return "Changement de centre d'accueil";
		case "SUBSCRIBER_TRANSFER_LEGAL_REPRESENTATIVE" :
			return "Transfert de représentant légal";
		case "SUBSCRIBER_UPDATE_SUBSCRIPTION_STATUS" :
			return "Changement de status";
		case "SUBSCRIBER_END_SUBSCRIPTION":
			return "Fin de l'inscription";
		case "SUBSCRIBER_TITRE_RELAIS_NOTIFICATION":
			return "Notification du titre relais";
		case "SUBSCRIBER_ADD_ATTACHED_FILE":
			return "Ajout d'un document attaché";
		case "SUBSCRIBER_RECEIVE_ATTACHED_FILE":
			return "Réception d'un document attaché";
		case "SUBSCRIBER_UNRECEIVE_ATTACHED_FILE":
			return "Suppression d'un document reçu";
		case "SUBSCRIBER_DELETE_ATTACHED_FILE":
			return "Suppression d'un document attaché";
		case "SUBSCRIBER_ADD_SUBSCRIPTION":
			return "Ajout d'un abonnement";
		case "SUBSCRIBER_DISABLE_SUBSCRIPTION":
			return "Désactivation d'un abonnement";
		case "SUBSCRIBER_ADD_TRANSPORT_TICKET":
			return "Ajout d'un titre de transport";
		case "SUBSCRIBER_DISABLE_TRANSPORT_TICKET":
			return "Désactivation d'un titre de transport";
		case "SUBSCRIBER_ADD_TRIPS":
			return "Ajout de parcours";
		case "SUBSCRIBER_DISABLE_TRIPS":
			return "Suppression de parcours";

		default:
			return state;
		}
	};
});


angular.module("app").filter("emailType", function () {
	return function (state) {
		switch (state) {
		case "RENEW_SUBSCRIPTION":
			return "Email de confirmation d'inscription";
		case "VALIDATION_SUBSCRIPTION":
			return "Email d'acceptation du dossier";
		case "SEND_BILL":
			return "Envoi d'une facture par email";
		case "SEND_TIMETABLE_BILL":
			return "Envoi d'un échéancier par email";
		case "SEND_INDISCIPLINE_PDF":
			return "Envoi d'une indicipline par email";
		case "SEND_CREDIT_NOTE":
			return "Envoi d'un avoir par email";
		case "SEND_TRAVEL_SUMMARY":
			return "Envoi de la fiche parcours";
		case "SEND_BILL_TO_CASH":
			return "Relance pour un règlement";
		case "SEND_MANDAT_REQUEST":
			return "Procédure de signature du Mandat";
		default:
			return state;
		}
	};
});

angular.module("app").filter("passengerStatus", function () {
	return function (state) {
		var stateFinal = "";
		switch (state) {
		case "ALREADY_FLASHED":
			stateFinal = "Déjà scannée";
			break;
		case "INVALID_FORMAT":
			stateFinal = "Format invalide";
			break;
		case "UNAUTHORIZED":
			stateFinal = "Non autorisée";
			break;
		case "OK":
			stateFinal = "Valide";
			break;
		default:
			stateFinal = state;
			break;
		}
		return stateFinal;
	};
});

angular.module("app").filter("convertBoolean", function () {
	return function (input) {
		if (input) {
			return "Oui";
		} else {
			return "Non";
		}
	};
});

angular.module("app").filter("underscoreless", function () {
	return function (input) {
		if (input) {
			return input.replace(/_/g, " ");
		}
	};
});

angular.module("app").filter("ucwords", function () {
	return function (input) {
		if (input) {
			input = input.toLowerCase().replace(/\b[a-z]/g, function (letter) {
				return letter.toUpperCase();
			});

		}
		return input;
	};
});

angular.module("app").filter("datetime", function () {
	return function (d) {
		return ("00" + (d.month + 1)).slice(-2) + "/" +
			("00" + d.date).slice(-2) + " - " +
			("00" + d.hours).slice(-2) + ":" +
			("00" + d.minutes).slice(-2) + ":" +
			("00" + d.seconds).slice(-2);
	};
});


angular.module("app").filter("translateModuleRights", function () {
	return function (input) {
		switch (input) {
		case "R" :
			return "LECTURE SEULE";
			break;
		case "W" :
			return "LECTURE / ECRITURE";
			break;
		default :
			return "AUCUN DROIT DEFINI";

		}
	};
});


/**
 * Format a CHouette 'dayTypes' table
 */
angular.module("app").filter("formatDayTypes", function () {
	return function (dayTypes) {
		var formatted = "";
		if (dayTypes.indexOf("Monday") > -1) {
			formatted += "Lu /";
		}
		if (dayTypes.indexOf("Tuesday") > -1) {
			formatted += " Ma /";
		}
		if (dayTypes.indexOf("Wednesday") > -1) {
			formatted += " Me /";
		}
		if (dayTypes.indexOf("Thursday") > -1) {
			formatted += " Je /";
		}
		if (dayTypes.indexOf("Friday") > -1) {
			formatted += " Ve /";
		}
		if (dayTypes.indexOf("Saturday") > -1) {
			formatted += " Sa /";
		}
		if (dayTypes.indexOf("Sunday") > -1) {
			formatted += " Di /";
		}
		if (formatted.length > 0) {
			formatted = formatted.substr(0, formatted.length - 1).trim();
		}
		return formatted || "Aucun jour sélectionné";
	};
});

angular.module("app").filter("iif", function () {
	return function (input, trueValue, falseValue) {
		return input ? trueValue : falseValue;
	};
});

/**
 * Format a string hh:mm:ss to display only hh:mm
 */
angular.module("app").filter("okinaStringDateTo_hh_mm", function () {
	return function (stringDate) {
		var formattedString;
		var splitted = stringDate.split(":");
		if (splitted.length === 3) {
			splitted.splice(2, 1);
			formattedString = splitted.join(":");
		} else {
			// if not in the expected hh:mm:ss format, leave it as it.
			formattedString = stringDate;
		}
		return formattedString;
	};
});

angular.module("app").filter("okinaIsoDateToUserDate", function () {
	return function (stringDate) {
		return dayjs(stringDate, "YYYY-MM-DD").format("DD/MM/YYYY");
	};
});

angular.module("app").filter("okinaJSDateToMomentCalendar", function () {
	return function (jsDate) {
		return dayjs().calendar(dayjs(jsDate));
	};
});

angular.module("app").filter("okinaJSDateToString", function () {
	return function (jsDate) {
		return dayjs(jsDate).format("DD/MM/YYYY");
	};
});

angular.module("app").filter("okinaStringDateToDateObject", function () {
	return function (okinaStringDate) {
		return dayjs(okinaStringDate, "HH:mm").toDate();
	};
});

angular.module("app").filter("okinaGender", function () {
	return function (genderValue) {
		return genderValue === "MALE" ? "Masculin" : "Féminin";
	};
});

angular.module("app").filter("boolean", function () {
	return function (boolean) {
		return boolean ? "Oui" : "Non";
	};
});

angular.module("app").filter("okinaStudentQualityStatus", function () {
	return function (status) {
		switch (status) {
		case "DEMI_PENSIONNAIRE": return "Demi pensionnaire";
		case "EXTERNE": return "Externe";
		case "INTERNE": return "Interne";
		case "RPI": return "RPI";
		case "APPRENTI": return "Apprenti";
		case "ETUDIANT": return "Étudiant";
		}
	};
});

angular.module("app").filter("okinaLegalRepresentativeType", function () {
	return function (status) {
		switch (status) {
		case "LEGAL_REPRESENTATIVE": return "Représentant légal";
		case "ORGANIZATION": return "---";
		case "FOSTER_FAMILY": return "Famille d'accueil";
		case "DROP_IN_CENTER": return "Centre d'accueil";
		}
	};
});

angular.module("app").filter('trusted', ["$sce", function($sce){
	return function(html){
		return $sce.trustAsHtml(html)
	}
}]);


